import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  email:string;
  otp:string;
  isVerifYOTP:number;
  userEmail:string;
  message:string;
  token:string;
  timerText = '';
  timer = 60;
  timerRef = null;
  isResendEnabled: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private helperService:HelperService) { }

  ngOnInit() {

    this.isVerifYOTP = 1;
    this.startTimer();
  }

  startTimer() {
    this.timerText = this.timer === 60 ? "1:00" : "0: " + this.timer;

    this.timerRef = setInterval(() => {
      
      this.timer -= 1;

      this.timerText =  "0: " + (this.timer > 9 ? this.timer : '0'+this.timer);

      if (this.timer === 0) {
        this.isResendEnabled = true;
        clearInterval(this.timerRef);
      }

    }, 1000);
  }

  sendOTP(){    

    this.apiService.sendOTP(this.email).subscribe((res: any) => {      
      this.isVerifYOTP = 2;
      alert("OTP Send Successfully");
    })

  }
  verifyOTP(){

    let verifyData = {

      "userEmail":this.email,"otp":this.otp

    }

    this.apiService.verifyOTP(verifyData).subscribe((res: any) => {
      
      this.userEmail = res.data.userEmail;
      this.token = res.data.token;
      this.helperService.setToken(this.helperService.studented_btoa(this.token));
      this.helperService.setEmail(this.userEmail);
      //this.helperService
      
      if(this.userEmail==this.email){
        this.router.navigateByUrl(`changePassword`);
      }
      else {
        this.message = "Email Address does not match/Wrong OTP";
        return;
      }
      
    },async err => {

      //console.log(err.error.meta.msg);
      this.message = err.error.meta.msg;

    }    
    )

  }

}
